import { AlertDialogActions } from "./components/AlertDialogAction";
import { VideoDialogActions } from "./components/VideoDialogAction";
import { BackDropActions } from "./components/BackDropAction";
import { InfoActions } from "./components/InfoAction";
import { VendorCreationActions } from "./vendor/VendorCreationAction";
import { VendorDetailActions } from "./vendor/VendorDetailAction";
import { CallOverVerificationActions } from "./vendor/CallOverVerificationAction";
import { DashboardFilterActions } from "./vendor/DashboardFilterAction";
import { VendorBlockDataAction } from "./vendor/VendorBlockDataAction";




const AllActions = {
  backDropActions: BackDropActions,
  infoActions: InfoActions,
  alertDialogActions: AlertDialogActions,
  videoDialogActions: VideoDialogActions,
  vendorCreationActions: VendorCreationActions,
  vendorDetailActions: VendorDetailActions,
  callOverVerificationAction:CallOverVerificationActions,
  dashboardFilterActions:DashboardFilterActions,
  VendorBlockDataActions : VendorBlockDataAction
};

export default AllActions;
